import { render, staticRenderFns } from "./AdminDepartment_edit.vue?vue&type=template&id=e71e5d62&"
import script from "./AdminDepartment_edit.vue?vue&type=script&lang=js&"
export * from "./AdminDepartment_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports